import React, { useState, useEffect } from 'react';

import api from "../../../../services/api";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {
  Input,
  Button,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Modal
} from "reactstrap";

export default ({ notify, empresa, ...props }) => {

  const [marcacoes, setMarcacoes] = useState([])
  const [marcacao, setMarcacao] = useState(null)
  const [alert, setAlert] = useState(null)

  const [columns, setColumns] = useState([
    {
      dataField: 'acoes',
      formatter: (cell, row) => acoesFormatter(cell, row)
    },
    {
      dataField: 'marcacao',
      text: 'Marcação',
      sort: true
    },
  ])

  useEffect(() => {
    if (marcacoes.length === 0) loadMarcacoes()
  }, [])



  async function removeMarcacao(marcacaoId) {
    try {
      await api.delete(`/common/empresas/${empresa.id}/marcacoes-padroes/${marcacaoId}`)
      loadMarcacoes()
      notify('success', 'Marcação removida')
    } catch (error) {
      console.log(error)
      notify('danger', 'Não foi possível remover marcação')
    }
    setAlert(null)
  }

  function handleRemoverMarcacao(marcacao) {
    confirmAlert(`Deseja realmente remover ${marcacao.marcacao} da empresa ${empresa.nome}?`,
      'danger',
      () => removeMarcacao(marcacao.id))
  }

  function handleAddMarcacao() {
    if (!marcacao) {
      return
    }
    confirmAlert(`Deseja realmente adicionar está marcação à ${empresa.nome}?`,
      'warning',
      () => addMarcacao())
  }

  async function addMarcacao() {
    try {
      await api.post(`/common/empresas/${empresa.id}/marcacoes-padroes/`, {
        marcacao
      })
      setMarcacao(null)
      loadMarcacoes()
      notify('success', 'Marcação adicionada')
    } catch (error) {
      console.log(error)
      notify('danger', 'Não foi possível adicionar marcação')
    }
    setAlert(null)
  }


  function confirmAlert(message, alertColor, onConfirm) {
    setAlert(<Modal
      className={`modal-dialog-centered modal-${alertColor}`}
      contentClassName={`bg-gradient-${alertColor}`}
      isOpen={true}
      toggle={() => setAlert(null)}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-notification">
          Atenção
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={setAlert(false)}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="py-3 text-center">
          <i className="fas fa-question-circle ni-3x" />
          <br />
          <br />
          <p>
            {message}
          </p>
        </div>
      </div>
      <div className="modal-footer">
        <Button
          className="btn-white"
          color="default"
          type="button"
          onClick={onConfirm}
        >
          Sim
        </Button>
        <Button
          className="text-white ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => setAlert(null)}
        >
          Fechar
        </Button>
      </div>
    </Modal>
    )
  }


  function acoesFormatter(cell, row) {
    return (<>
      <div class="btn-group" role="group" aria-label="Basic example">
        <Button
          className="btn-sm"
          color="danger"
          onClick={() => handleRemoverMarcacao(row)}
          outline>
          <i class="fas fa-trash"></i>
        </Button>
      </div>
    </>)
  }


  async function loadMarcacoes() {
    try {
      const response = await api.get(`/common/empresas/${empresa.id}/marcacoes-padroes?`)
      if (response.data) {
        setMarcacoes(response.data)
      }
    } catch (error) {
      console.log(error)
      notify('danger', 'Não foi possível carregar as marcações')
    }
  }

  function handleInputEnter(e) {
    if (e.key === 'Enter') {
      handleAddMarcacao()
    }
  }


  return (
    <>
      {alert}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Row>
          <Col lg={12} md={12}>
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example-number-input"
              >
                Marcação
              </label>
              <InputGroup className="mb-3">
                <div
                  style={{
                    width: '400px'
                  }}
                >
                  <Input
                    className="form-control"
                    placeholder='Marcação...'
                    onChange={(e) => setMarcacao(e.target.value)}
                    value={marcacao}
                    onKeyDown={handleInputEnter}
                  />
                </div>
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    type="button"
                    outline
                    onClick={handleAddMarcacao}
                    className="btn-icon btn-3"
                  >
                    <span className="btn-inner--icon">
                      <i className="ni ni-fat-add"></i>
                    </span>
                    <span className="btn-inner--text">Adicionar Marcação</span>
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>


      </div>
      <Row>
        <Col>
          <ToolkitProvider
            data={marcacoes}
            keyField="name"
            columns={columns}
            search
          >
            {props => (
              <div className="py-4">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                />
              </div>
            )}
          </ToolkitProvider>
        </Col>
      </Row>
    </>
  );
}
